"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Board = void 0;
const logic_types_1 = require("../logic-types");
const helper_1 = require("../../../common/helper");
class Board {
    constructor(deck, croupier, playerPiles, waste) {
        this.deck = deck;
        this.croupier = croupier;
        this.playerPiles = playerPiles;
        this.waste = waste;
    }
    clone() {
        return new Board(this.deck.clone(), this.croupier.clone(), this.playerPiles.clone(), this.waste.clone());
    }
    updateFromCopy(board) {
        this.deck = board.deck;
        this.croupier = board.croupier;
        this.playerPiles = board.playerPiles;
        this.waste = board.waste;
    }
    getPileByCardIndex(index) {
        if (this.deck.containsCardIndex(index)) {
            return this.deck;
        }
        if (this.croupier.containsCardIndex(index)) {
            return this.croupier;
        }
        if (this.waste.containsCardIndex(index)) {
            return this.waste;
        }
        const playerPile = this.playerPiles.getPileByCardIndex(index);
        if (playerPile) {
            return playerPile;
        }
        throw new Error(`Pile not found that contains card with index: ${index}`);
    }
    getPileByCardId(cardId) {
        if (this.deck.containsCardId(cardId)) {
            return this.deck;
        }
        if (this.croupier.containsCardId(cardId)) {
            return this.croupier;
        }
        if (this.waste.containsCardId(cardId)) {
            return this.waste;
        }
        return this.playerPiles.getPileByCardId(cardId);
    }
    getPileByPileId(pileId) {
        switch (pileId) {
            case logic_types_1.PileId.Deck:
                return this.deck;
            case logic_types_1.PileId.Croupier:
                return this.croupier;
            case logic_types_1.PileId.Player1:
            case logic_types_1.PileId.Player2:
            case logic_types_1.PileId.Player3:
            case logic_types_1.PileId.Player4:
                return this.playerPiles.getPileByPileId(pileId);
            case logic_types_1.PileId.Waste:
                return this.waste;
            default:
                (0, helper_1.assertNever)(pileId, `Pile not found with id: ${pileId}`);
        }
    }
    getCardByCardId(cardId) {
        const pile = this.getPileByCardId(cardId);
        return pile === null || pile === void 0 ? void 0 : pile.getCardByCardId(cardId);
    }
    getCardByCardIndex(index) {
        const pile = this.getPileByCardIndex(index);
        return pile.getCardByCardIndex(index);
    }
    lastDeckCard() {
        return this.deck.lastCard;
    }
    cardsInPlay() {
        const allCards = [];
        this.deck.combine(allCards);
        this.croupier.combine(allCards);
        this.playerPiles.combine(allCards);
        return allCards;
    }
    parentCard(childCard) {
        const pile = this.getPileByCardIndex(childCard.index);
        return pile.parentCard(childCard);
    }
}
exports.Board = Board;
